export default {
  ApplicationInfo: 'Информация',
  Game: 'Игра',
  Account: 'Аккаунт',
  Server: 'Сервер',
  CharacterName: 'Персонаж',
  PlatformOrderNumber: 'Номер заказа (платформа)',
  Amount: 'Сумма',
  InvoiceMethod: 'Данные счёта',
  InvoiceByTotalOrderAmount: 'Выставить счёт на общую сумму нескольких заказов',
  InvoiceByOrderAmountSeparately:
    'Выставлять отдельные счета на каждый заказ в зависимости от его суммы',
  PhoneNumber: 'Контактный номер',
  Name: 'Имя',
  Address: 'Адрес',
  InvoiceTitle: 'Счёт на имя',
  PersonalTitleOnlyNoCompany:
    'Укажите ваше имя. Не указывайте название компании или организации.',
  ReceivingEmail: 'Эл. почта',
  Remarks: 'Примечание',
  InputContent: 'Введите здесь',
  ApplicationSubmittedSuccessfully: 'Заявка отправлена',
  InvoiceApplicationSubmittedSuccessfully:
    'Ваша заявка на счёт отправлена.\r\nОна будет обработана в течение 7 рабочих дней. Не забудьте проверить свою электронную почту.',
  Confirm: 'Принять',
  Submit: 'Отправить',
  ApplicationSubmissionFailed: 'Не удалось отправить заявку',
  InvoiceApplicationFailed:
    'Заявка на счёт не отправлена. Обновите страницу и попробуйте ещё раз или обратитесь в службу поддержки.',
  InvoiceApplicationSubmitted:
    'Заявка отправлена. Повторная отправка не требуется.',
  PleaseEnterName: 'Укажите имя',
  PleaseEnterAddress: 'Укажите адрес',
  PleaseEnterInvoiceTitle: 'Укажите имя получателя',
  PleaseEnterEmail: 'Укажите адрес эл. почты',
  PleaseEnterRemarks: 'Добавьте примечание (необязательно)',
  NumberParsingError: 'Некорректное число',
  PleaseEnterValidEmailFormat: 'Введите верный адрес электронной почты',
  IncompleteInformation: 'Информация неполная, пожалуйста, проверьте',
  ExpandAll: 'Показать все'
};
